/**
 *  Filters state module file
**/

export const defaultFilters = () => [
  {
    key: 'fulltext',
    enabled: true,
    value: null
  },
  {
    key: 'viewport',
    enabled: false,
    value: []
  }
]

export const state = {
  filters: defaultFilters()
}
